import { CSSProperties } from 'react'
import { TextStyle } from '../../../types'

export function cssFromTextStyle(style: TextStyle): CSSProperties {
    const colors = style.color.split(',')

    const css: CSSProperties = {
        fontFamily: style.fontFamily,
        fontWeight: style.fontWeight,
    }

    if (colors.length > 1) {
        css.background = `linear-gradient(45deg, ${colors.join(', ')})`
        css.backgroundClip = 'text'
        css.color = 'transparent'
        css.WebkitBackgroundClip = 'text'
    } else {
        css.color = colors[0]
    }

    return css
}
